import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export default Wrapper;
